/**
 * Amplitude rejects user_id / device_id shorter than minIdLength (default 5).
 * Prefix numeric Aidemia ids so `1` → `psy_1` stays valid even if minIdLength is raised.
 */
export function toAmplitudeUserId(
  userId: string | null | undefined,
): string | undefined {
  const raw = userId?.trim();
  if (!raw) return undefined;
  if (raw.startsWith("psy_")) return raw;
  return `psy_${raw}`;
}
